import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboardIcon, FolderKanbanIcon, SettingsIcon, ExternalLinkIcon, BoxIcon, UserIcon, FlaskConicalIcon, PenToolIcon, MusicIcon, MailIcon, GamepadIcon, LogOutIcon, BarChart2Icon, BellIcon, PanelLeftCloseIcon, PanelLeftOpenIcon } from 'lucide-react';
import { useAuth } from '../../lib/auth';
export function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    logout
  } = useAuth();
  // ISSUE 2: Collapsible sidebar state
  const [collapsed, setCollapsed] = useState(false);
  const handleLogout = () => {
    logout();
    navigate();
  };
  const navItems = [{
    name: 'Dashboard',
    path: '/admin',
    icon: LayoutDashboardIcon
  }, {
    name: 'About',
    path: '/admin/about',
    icon: UserIcon
  }, {
    name: 'Work',
    path: '/admin/work',
    icon: FolderKanbanIcon
  }, {
    name: 'Experiments',
    path: '/admin/experiments',
    icon: FlaskConicalIcon
  }, {
    name: 'Writing',
    path: '/admin/writing',
    icon: PenToolIcon
  }, {
    name: 'Music',
    path: '/admin/music',
    icon: MusicIcon
  }, {
    name: 'Contact',
    path: '/admin/contact',
    icon: MailIcon
  }, {
    name: 'Game',
    path: '/admin/game',
    icon: GamepadIcon
  }];
  const systemItems = [{
    name: 'Notifications',
    path: '/admin/notifications',
    icon: BellIcon
  }, {
    name: 'Analytics',
    path: '/admin/analytics',
    icon: BarChart2Icon
  }, {
    name: 'Media',
    path: '/admin/media',
    icon: BoxIcon
  }, {
    name: 'Settings',
    path: '/admin/settings',
    icon: SettingsIcon
  }];
  const NavLink = ({
    item
  }: {
    item: {
      name: string;
      path: string;
      icon: any;
    };
  }) => {
    const isActive = location.pathname === item.path || item.path !== '/admin' && location.pathname.startsWith(item.path);
    return <Link to={item.path} title={collapsed ? item.name : undefined} className={`flex items-center gap-3 px-4 py-3 rounded-none font-mono text-sm transition-colors ${isActive ? 'bg-primary/10 text-primary border-l-2 border-primary' : 'text-muted-foreground hover:bg-secondary hover:text-foreground border-l-2 border-transparent'} ${collapsed ? 'justify-center px-3' : ''}`} data-id="element-642">
        <item.icon className="w-4 h-4 shrink-0" data-id="element-643" />
        {!collapsed && item.name}
      </Link>;
  };
  return <div className="min-h-screen bg-background flex text-foreground" data-id="element-644">
      {/* Sidebar */}
      <aside className={`${collapsed ? 'w-16' : 'w-64'} border-r border-border bg-card flex flex-col transition-all duration-300 shrink-0`} data-id="element-645">
        <div className={`h-16 flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-6'} border-b border-border shrink-0`} data-id="element-646">
          {!collapsed && <Link to="/admin" className="font-display text-xl font-bold tracking-tight" data-id="element-647">
              SINKA<span className="text-primary" data-id="element-648">.</span> CMS
            </Link>}
          <button onClick={() => setCollapsed(!collapsed)} className="p-1.5 text-muted-foreground hover:text-foreground transition-colors" aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} data-id="element-649">
            {collapsed ? <PanelLeftOpenIcon className="w-4 h-4" data-id="element-650" /> : <PanelLeftCloseIcon className="w-4 h-4" data-id="element-651" />}
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-6 flex flex-col" data-id="element-652">
          <nav className={`${collapsed ? 'px-2' : 'px-4'} space-y-1 mb-8`} data-id="element-653">
            {!collapsed && <div className="px-4 mb-2 font-mono text-[10px] uppercase tracking-widest text-muted-foreground" data-id="element-654">
                Content
              </div>}
            {navItems.map(item => <NavLink key={item.name} item={item} data-id="element-655" />)}
          </nav>

          <nav className={`${collapsed ? 'px-2' : 'px-4'} space-y-1`} data-id="element-656">
            {!collapsed && <div className="px-4 mb-2 font-mono text-[10px] uppercase tracking-widest text-muted-foreground" data-id="element-657">
                System
              </div>}
            {systemItems.map(item => <NavLink key={item.name} item={item} data-id="element-658" />)}
          </nav>
        </div>

        <div className={`${collapsed ? 'px-2' : 'p-4'} border-t border-border space-y-2 shrink-0 py-4`} data-id="element-659">
          <Link to="/" target="_blank" title={collapsed ? 'View Live Site' : undefined} className={`flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-4'} py-3 text-muted-foreground hover:text-foreground font-mono text-sm transition-colors`} data-id="element-660">
            <ExternalLinkIcon className="w-4 h-4 shrink-0" data-id="element-661" />
            {!collapsed && 'View Live Site'}
          </Link>
          <button onClick={handleLogout} title={collapsed ? 'Log Out' : undefined} className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-4'} py-3 text-muted-foreground hover:text-destructive font-mono text-sm transition-colors`} data-id="element-662">
            <LogOutIcon className="w-4 h-4 shrink-0" data-id="element-663" />
            {!collapsed && 'Log Out'}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-664">
        <div className="flex-1 overflow-y-auto" data-id="element-665">
          <Outlet data-id="element-666" />
        </div>
      </main>
    </div>;
}
;
'>';